module.exports = __webpack_public_path__ + "static/media/logo-pigment.0b49893e.svg";